import React, { useEffect, useState } from 'react';

const RefundList = () => {
  const [refunds, setRefunds] = useState([]);

  // Fetch refund data from PHP backend
  const fetchRefunds = async () => {
    try {
      const response = await fetch('https://st.tjdstore.in/api/get_refunds.php');
      const data = await response.json();
      setRefunds(data);
    } catch (err) {
      console.error('Error fetching refunds:', err);
    }
  };

  // Mark a refund as "Done"
  const markAsDone = async (id) => {
    try {
      const response = await fetch('https://st.tjdstore.in/api/update_status.php', {
        method: 'POST',
        body: new URLSearchParams({ id })
      });

      const result = await response.json();
      alert('Status updated to Done!');
      fetchRefunds(); // Refresh the list
    } catch (err) {
      console.error('Error updating status:', err);
    }
  };

  useEffect(() => {
    fetchRefunds();
  }, []);

  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-header bg-secondary text-white">
          Refund Requests
        </div>
        <div className="card-body">
          {refunds.length === 0 ? (
            <p>No refund records found.</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead className="table-dark">
                  <tr>
                    <th>Order ID</th>
                    <th>Type</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {refunds.map((refund) => (
                    <tr key={refund.id}>
                      <td>{refund.order_id}</td>
                      <td>{refund.refund_type}</td>
                      <td>{refund.description || '-'}</td>
                      <td>
                        <span
                          className={`badge ${
                            refund.status === 'Done'
                              ? 'bg-success'
                              : 'bg-warning text-dark'
                          }`}
                        >
                          {refund.status}
                        </span>
                      </td>
                      <td>{refund.created_at}</td>
                      <td>
                        {refund.status !== 'Done' ? (
                          <button
                            className="btn btn-sm btn-success"
                            onClick={() => markAsDone(refund.id)}
                          >
                            Mark Done
                          </button>
                        ) : (
                          <span className="text-muted">Completed</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RefundList;
